<div class="loading" [ngClass]="{ 'full-screen': fullScreen(), 'small-size': !fullScreen() }">
  <div class="loading-content">
    <img ngSrc="images/logo/small-logo.svg" class="logo" alt="Logo" fill priority />
    <div class="loader"></div>
  </div>
</div>
